<template>
  <div class="scale">
    <scale-item
      :labels="issue.labels"
      @click="onChangeSelectVal"
      :select-value="issue.value"
      :show-value="issue.show_option_value"
      :show-desc="issue.show_option_desc"
      :style-handler="getActiveColor"
    />
    <div v-if="issue.show_unknown" class="unknown-box pr-5">
      <van-radio-group :value="issue.value">
        <van-radio name="unknown" @click="issue.value = 'unknown'">
          <span class="text-theme-black-650">{{ issue.unknown_text }}</span>
          <template v-slot:icon="{ checked }">
            <icon-radio :value="checked" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import ScaleItem from '@/questions/scale/ScaleItem'
import IconRadio from '@/components/base/IconRadio'

export default {
  name: 'NPSScale',
  components: { IconRadio, ScaleItem },
  changeExpr: 'issue.value',
  methods: {
    onChangeSelectVal(item) {
      this.issue.value = item.id
    },
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx)
    }
  }
}
</script>
